import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { EmpleadosServicio } from '../../../services/empleado.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { QuestionBase } from '../../../helpers/dynamic-form/question-base';
import { DropdownQuestion } from '../../../helpers/dynamic-form/question-dropdown';
import { TextboxQuestion } from '../../../helpers/dynamic-form/question-textbox';

@Component({
  selector: 'app-preguntas-secretas',
  templateUrl: './preguntas-secretas.component.html',
  styleUrls: ['./preguntas-secretas.component.css']
})
export class PreguntasSecretasComponent implements OnInit {
  form: FormGroup;
  loaded = false;
  loading = false;
  questions: QuestionBase<any>[] = [];
  empleado: string;
  constructor(private empleadoService: EmpleadosServicio, public activeModal: NgbActiveModal) {
    this.initPreguntas();
  }

  ngOnInit() {
    this.empleado = this.empleadoService.datosEmpleado.nombreCompleto;
  }

  ChangeForm(event) {
    if (event.value) {
      this.form = event;
    }
  }


  private initPreguntas(): void {
    this.empleadoService.obtenerPreguntasSecretas()
    .subscribe((res: any) => {
      this.questions = this.initForm(res);
      console.log(res);
      setTimeout(() => this.loaded = true, 1);
    });
  }

  private initForm(questions: Array<any>): any {
    const qb: QuestionBase<any>[] = [];
    const options = [];
    questions.map((data, i) => options.push({key: data.ID_PREGUNTA_SECRETA, value: data.pregunta}) );
    for (let i = 1; i <= 3; i++) {
      qb.push(new DropdownQuestion({
        key: `p_${i}`,
        label: `Pregunta #${i}`,
        options,
        value: questions[i - 1].ID_PREGUNTA_SECRETA,
        required: true,
        order: i
      }), new TextboxQuestion({
        key: `r_${i}`,
        label: `Respuesta #${i}`,
        value: '',
        required: true,
        order: i
      }));
    }
    return qb.sort((a, b) => a.order - b.order);
  }

  guardarRespuestas(): void {
    if (this.form.valid && !this.loading) {
      this.loading = true;
      Object.defineProperty(this.form.value, 'ID_EMPLEADO', { value: this.empleadoService.datosEmpleado.ID_EMPLEADO, enumerable: true });

      this.empleadoService.guardarRespuestasPgSecret(this.form.value)
      .subscribe(res => {
        setTimeout(() => {
          this.loading = false;
          this.activeModal.close(res);
        }, 1);
      });
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/modals/preguntas-secretas/preguntas-secretas.component.ts